function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './EventsFeatureCarousel.css';
import React, { useEffect, useRef, useState } from 'react';
import { canUseDOM, generatrURLFromTags, get, getDictionaryItem, getPageThemeColors, getTags } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { convertToAnalyticObject } from '../../utils/analytics';
import ScrollAnimation from 'react-animate-on-scroll';
import getListing, { generateSeeMoreTagsFromRules, isTagsRule, loadCategoryAlgoliaResults } from '../../utils/getListing';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import EventsFeatureCarouselItem from './components/EventsFeatureCarouselItem';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import throttle from 'lodash/throttle';
import { useIsVisible } from '../../utils/useIsVisible';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { getTopPicksStorage } from '../atoms/FavouriteBtn/top_picks_apis';
import { idConverter } from '../atoms/FavouriteBtn/FavouriteBtn';
import RouterLink from '../atoms/RouterLink';
const EventsFeatureCarousel = _ref => {
  let {
    fields,
    params,
    route
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [isHidden, setIsHidden] = React.useState(false);
  const ref = useRef();
  const isVisible = useIsVisible(ref);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const indexName = get(params, 'SearchIndex');
  const searchCount = Number(get(params, 'SearchCount'));
  const allValues = [];
  const [searchResults, setSearchResults] = useState([]);
  const {
    isPersonalised
  } = sitecoreContext;
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const contextItem = get(fields, 'data.contextItem');
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const parentId = get(fields, 'data.contextItem.parent.parentId', '').toLowerCase();
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const isTagsRuleUsed = isTagsRule(tagsRule);
  const contextItemId = get(fields, 'data.contextItem.id');
  let currentLang = get(sitecoreContext, 'language');
  if (currentLang === 'no') {
    currentLang = 'nob';
  }
  const typeEvent = 'type:Event';
  let dummyId;
  if (process.env.STORYBOOK_MODE) {
    dummyId = '6a1d9e4935ad4273804e7cbc56f0d62b';
  }
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  const {
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: searchResults,
    conditions: [algoliaScoredCondition(allValues)]
  });
  const formatTagsRuleToFilters = function () {
    let withType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let facetsFilters = [withType && [typeEvent]];
    if (isTagsRuleUsed) {
      let parsedTR = JSON.parse(tagsRule);
      if (parsedTR.length) {
        parsedTR.forEach(rule => {
          facetsFilters.push(rule);
        });
      }
    }
    return facetsFilters;
  };
  const tagsList = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : considerPageLevelTags ? [...contextItemTags, ...datasourceTags] : [...datasourceTags];
  React.useEffect(() => {
    setSeeMoreURLTags(generatrURLFromTags(tagsList));
    if (isVisible) {
      if (isPersonalised && intentsLength) {
        (async () => {
          const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, typeEvent, searchCount, isTagsRuleUsed ? formatTagsRuleToFilters(false) : considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags], [contextItemId ? `curators.curators.Id:${contextItemId}` : ''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
          setSearchResults(hits);
          refreshTracking();
        })();
      } else {
        let filters = currentPageID ? `NOT objectID:${currentPageID}` : '';
        if (parentId) {
          filters = currentPageID ? `NOT objectID:${currentPageID} AND NOT objectID:${parentId}` : '';
        }
        let itemFilter = {
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFilters(true) : [[typeEvent], considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags]],
          filters
        };
        let results = [];
        let hiddenResults = '';
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          results.push(hits && hits.hits);
          results[0].map(result => {
            hiddenResults += ` AND NOT objectID:${result.objectID}`;
          });
          if (hits && hits.hits.length !== searchCount) {
            let itemFilter = {
              hitsPerPage: searchCount - hits.hits.length,
              facetFilters: [typeEvent],
              filters: currentPageID ? ` (NOT objectID:${currentPageID} ${hiddenResults})` : ` (NOT objectID:${dummyId} ${hiddenResults})`
            };
            getListing(indexName, itemFilter, algoliaSettings).then(hits => {
              results.push(hits && hits.hits);
              let finalResults = results[0].concat(results[1]);
              finalResults.length ? setIsHidden(false) : setIsHidden(true);
              setSearchResults(finalResults);
            });
          } else {
            results[0].length ? setIsHidden(false) : setIsHidden(true);
            results[0] && setSearchResults(results[0]);
          }
        });
      }
    }
  }, [isPersonalised, isVisible]);
  const carouselWrapperRef = useRef(null);
  const [titleHeight, setTitleHeight] = useState(0);
  const [descHeight, setDescHeight] = useState(0);
  const [itemDateHeight, setitemDateHeight] = useState(0);
  const [sightHeight, setsightHeight] = useState(0);
  let countHeights;
  const titleEventCheck = get(fields, 'data.datasource.title.jss.value');
  const titleEvent = get(fields, 'data.datasource.title.jss', '');
  const descriptionEvent = get(fields, 'data.datasource.description.jss.value');
  const descriptionEventCheck = get(fields, 'data.datasource.description.jss', '');
  const ctaLink = get(fields, 'data.datasource.cTALink.jss.value.href');
  const ctaLabel = get(fields, 'data.datasource.ctaLabel.jss.value');
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const multipleDates = getDictionaryItem(moduleDictionary, 'multipleDates') || 'Multiple days, next on';
  const greyCards = params !== undefined && params['Card Color'] === 'Grey' ? true : false;
  const ThemeBasedCards = params !== undefined && params['Card Color'] === 'Theme Based' ? true : false;
  const whiteCards = params !== undefined && params['Card Color'] === 'White' ? true : false;
  const ThemeBased = params !== undefined && params['Background Color'] === 'Theme Based' ? true : false;
  const grey = params !== undefined && params['Background Color'] === 'Grey' ? true : false;
  const white = params !== undefined && params['Background Color'] === 'White' ? true : false;
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const styleThemeHexColor = ThemeBased ? {
    '--eventsFeatureCarousel-theme-hex-card-background-color': '#fff',
    '--eventsFeatureCarousel-theme-hex-container-background-color': selectedPrimaryColor,
    '--eventsFeatureCarousel-theme-hex-background-color': selectedPrimaryColor,
    '--eventsFeatureCarousel-title-color': 'var(--main-color-text)',
    '--eventsFeatureCarousel-theme-hex-active-color': selectedActiveColor,
    '--eventsFeatureCarousel-dots-color': 'var(--main-color-text)',
    '--eventsFeatureCarousel-arrows-color': 'var(--main-color--active)',
    '--eventsFeatureCarousel-card-title-color': '#000',
    '--eventsFeatureCarousel-card-text-color': '#505050',
    '--eventsFeatureCarousel-card-desc-color': 'var(--main-color-text)'
  } : {
    '--eventsFeatureCarousel-theme-hex-card-background-color': greyCards && !grey ? '#f4f4f4' : ThemeBasedCards && !grey ? selectedPrimaryColor : '#fff',
    '--eventsFeatureCarousel-theme-hex-container-background-color': ThemeBasedCards && !grey ? '#fff' : grey ? '#f4f4f4' : '#fff',
    '--eventsFeatureCarousel-theme-hex-background-color': selectedPrimaryColor,
    '--eventsFeatureCarousel-title-color': '#000',
    '--eventsFeatureCarousel-theme-hex-active-color': selectedActiveColor,
    '--eventsFeatureCarousel-dots-color': '#505050',
    '--eventsFeatureCarousel-arrows-color': 'var(--main-color)',
    '--eventsFeatureCarousel-card-title-color': ThemeBasedCards && !grey ? 'var(--main-color-text)' : '#000',
    '--eventsFeatureCarousel-card-text-color': ThemeBasedCards && !grey ? 'var(--main-color-text)' : '#505050',
    '--eventsFeatureCarousel-card-desc-color': '#505050'
  };
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (carouselWrapperRef.current && !!searchResults.length) {
        const textSightHeight = Array.from(carouselWrapperRef.current.querySelectorAll(`.eventsFeatureCarousel__item-title`)).map(item => {
          return item.offsetHeight;
        });
        const dateHeight = Array.from(carouselWrapperRef.current.querySelectorAll(`.eventsFeatureCarousel-date`)).map(item => {
          return item.offsetHeight;
        });
        const titleHeights = Array.from(carouselWrapperRef.current.querySelectorAll(`.eventsFeatureCarousel__item-title`)).map(item => {
          return item.offsetHeight;
        });
        const descHeights = Array.from(carouselWrapperRef.current.querySelectorAll(`.eventsFeatureCarousel__text`)).map(item => {
          return item.offsetHeight;
        });
        setTitleHeight(Math.max(...titleHeights));
        setDescHeight(Math.max(...descHeights));
        setsightHeight(Math.max(...textSightHeight));
        setitemDateHeight(Math.max(...dateHeight));
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize, searchResults]);
  const [activeTopPicks, setActiveTopPicks] = React.useState([]);
  const toggleActiveTopPicks = objectId => {
    const id = idConverter(objectId);
    let topPicks = getTopPicksStorage();
    let topPicksList = topPicks.list || [];
    let list = [...topPicksList.map(el => el.itemId)];
    if (list.includes(id)) {
      const index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else {
      list.push(id);
    }
    setActiveTopPicks(list);
  };
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      let topPicks = getTopPicksStorage();
      let topPicksList = topPicks.list || [];
      setActiveTopPicks(topPicksList.map(el => el.itemId));
    }
  }, []);
  if (!fields) {
    console.warn('EventsFeatureCarousel component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [EventsFeatureCarousel component is empty: please provide data source]");
    }
    return null;
  }
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderTileItems = () => {
    return searchResults.map(item => /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.objectID
    }, /*#__PURE__*/React.createElement(EventsFeatureCarouselItem, _extends({}, item, {
      multipleDates: multipleDates,
      params: params,
      eventsAnalytics: eventsAnalytics,
      toggleActiveTopPicks: id => toggleActiveTopPicks(id),
      activeTopPicks: activeTopPicks,
      lang: currentLang,
      ThemeBasedCards: ThemeBasedCards
    }))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    styleThemeHexColor: styleThemeHexColor,
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isHidden: true
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    ref: carouselWrapperRef,
    style: {
      '--title-height': titleHeight,
      '--desc-height': descHeight,
      '--sight-height': sightHeight,
      '--date-height': itemDateHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: titleEventCheck ? 'eventsFeatureCarousel__title-block' : 'eventsFeatureCarousel__title-block_without-title'
    }, /*#__PURE__*/React.createElement("div", null, titleEventCheck && searchResults.length > 1 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "eventsFeatureCarousel__title",
      field: titleEvent
    })) : null, descriptionEventCheck && searchResults.length > 1 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1.6
    }, /*#__PURE__*/React.createElement("p", {
      className: 'eventsFeatureCarousel__description'
    }, descriptionEvent, " "))) : null), /*#__PURE__*/React.createElement("div", {
      className: `btn-group ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['optionsPreviousClickAnalytics'], params)), true, false), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['optionsNextClickAnalytics'], params)), true, false))), renderCarousel(renderTileItems(), {
      responsive: {
        mobile: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "eventsFeatureCarousel_dots_and_cta_wrapper"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['optionsBubblesClickAnalytics'], params))), ctaLink && ctaLabel && searchResults.length > 1 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "eventsFeatureCarousel_under-dots-wrapper",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: `eventsFeatureCarousel_under-dots btn btn-secondary`,
      href: ctaLink,
      title: `${ctaLabel}`,
      linktype: '',
      linksTarget: '',
      onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params), [titleEvent.value, ctaLabel])
    }, ctaLabel)) : null));
  })))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    isHidden,
    anchorUrlParameter,
    styleThemeHexColor
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: styleThemeHexColor
  }, children) : null);
};
export const commonStyles = "c1w9se9j";
const ltrStyles = "l1i55x86";
const rtlStyles = "rbqf6fg";
export default EventsFeatureCarousel;